export default __webpack_public_path__ + "static/media/char_head_prem_004.372264e3.png";